<div class="card card-box mb-5">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="far fa-star"></i> Notice </b>
    </div>
    <div class="card-header--actions">
      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="addNew()">
                      <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>
                      </span>
        <span class="btn-wrapper--label">
                          New Note
                      </span>
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-between px-4 py-3">
    <div class="search-wrapper">
          <span class="icon-wrapper text-black">
            <fa-icon [icon]="['fas', 'search']"></fa-icon>
          </span>
      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">
    </div>
  </div>
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">TITLE</th>
        <th class="bg-white text-center">DESCRIPTON</th>
        <th class="bg-white text-center">VIEW</th>
        <th class="bg-white text-center">ACTION</th>
        <!--        <th class="bg-white text-center">Actions</th>-->
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pac of reviwes">
        <td class="font-weight-bold text-center">
          {{pac.title}}
        </td>
        <td class="text-center">
          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">
             {{(pac.description| slice:0:30)+ '...'}}
          </span>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-success btn-sm" (click)="viewMore(pac)">
            <i class="fas fa-eye"></i>
          </button>
        </td>
        <td class="font-weight-bold text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-warning" (click)="update(pac)">
              <i class="fas fa-upload"></i>
            </button>
            <button type="button" class="btn btn-danger" (click)="dlete(pac.id)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </td>

        <!--        <td class="text-center">-->
        <!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
        <!--&lt;!&ndash;            <button type="button" class="btn btn-success" (click)="approve(pac.id)" ><i class="fas fa-check-circle"></i></button>&ndash;&gt;-->
        <!--            <button type="button" class="btn btn-danger" (click)="reject(pac.id)"><i-->
        <!--              class="far fa-trash-alt"></i></button>-->

        <!--          </div>-->
        <!--        </td>-->
      </tr>

      </tbody>
    </table>
  </div>
  <div class="card-footer py-3 d-flex justify-content-between">

  </div>
</div>

<div bsModal #view="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Notice</h6>
        <button type="button" class="close" (click)="view.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <h4 class="text-primary">{{noteTitle}}</h4>

          <p>{{note}}</p>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="view.hide()">Close</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">New Notify</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <h4>News</h4>
          <form [formGroup]="newsForm">
            <div class="m-2">
              <input class="form-control" placeholder="Title" type="text" formControlName="title">
            </div>
            <div class="m-2">
              <textarea class="form-control" placeholder="Description" formControlName="desc" cols="30" rows="10"></textarea>
            </div>

          </form>
          <div class="m-2">
<!--            <button class="btn btn-success">Submit</button>-->
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <button *ngIf="up!=true" type="button" class="btn btn-success ml-auto" [disabled]="!newsForm.valid"  (click)="createNotice()">Save changes</button>
        <button *ngIf="up==true" type="button" class="btn btn-warning ml-auto" [disabled]="!newsForm.valid"  (click)="updateNotice()">Update </button>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
